// @flow
import { put, takeLatest, call, select } from 'redux-saga/effects';
import {
  START_SYNC
} from '../actions/types';
import {
	getLivePods
} from '../services/pods.js';
import { completeSync, errorSync } from '../actions/app';
import { selectPod } from '../actions/pods';
import { showErrorMsg } from '../actions/snackbar';
import { setCookie } from "../utils";


function* sync(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { selectedPod } = yield select((state) => state.pod || {});
    if (!sessionId || !selectedPod) {
      yield put(completeSync());
    }
    const res = yield call(getLivePods, '', {}, sessionId);
		const { machines = [] } = res;
    const newPod = machines.find(({vm_imei_id}) => vm_imei_id === selectedPod.vm_imei_id);
    if (newPod) {
      yield put(selectPod(newPod));
      setCookie('pod', JSON.stringify(newPod));
    }
    yield put(completeSync());
	} catch (error) {
    yield put(errorSync(error));
		yield put(showErrorMsg(error.message));
	}
}

export function* watchApp(): Iterable<any> {
	yield takeLatest(START_SYNC, sync);
}